/** 제품 디자인 포트폴리오·상세 공통 데이터 */

import { sortPortfolioByYear } from './portfolioYearSort'
import {
    ducatiLaserDesignCase,
    ducatiLaserPortfolioCard,
    DUCATI_LASER_SLUG,
} from './ducatiLaserCaseData'
import {
    moduInhalerDesignCase,
    moduInhalerPortfolioCard,
    MODU_INHALER_SLUG,
} from './moduInhalerCaseData'
import {
    arrowDroneDesignCase,
    arrowDronePortfolioCard,
    ARROW_DRONE_SLUG,
} from './arrowDroneCaseData'
import {
    greenViewDesignCase,
    greenViewPortfolioCard,
    GREEN_VIEW_SLUG,
} from './greenViewCaseData'
import {
    infantNasalAspiratorDesignCase,
    infantNasalAspiratorPortfolioCard,
    INFANT_NASAL_ASPIRATOR_SLUG,
} from './infantNasalAspiratorCaseData'
import {
    petFriendsDesignCase,
    petFriendsPortfolioCard,
    PET_FRIENDS_SLUG,
} from './petFriendsCaseData'

export const PRODUCT_DESIGN_PORTFOLIO_PATH = '/codam-design/product-design'

export const PRODUCT_DESIGN_PARENT_PATH = '/codam-design'

export const PRODUCT_MALRYEOSHU_IMG = '/assets/img/design/product-malryeoshu-s.png'

export const PRODUCT_MALRYEOSHU_DETAIL_IMG =
    '/assets/img/design/product-malryeoshu-s-detail.png'

export const PRODUCT_MALLYEOJWO_PET_IMG = '/assets/img/design/product-mallyeojwo-pet-dryer.png'

/** @deprecated 초기 제품 시트 — 갤러리·상세는 lifestyle / collage 사용 */
export const PRODUCT_RICE_KEEPER_IMG = '/assets/img/design/product-rice-keeper.png'

export const PRODUCT_RICE_KEEPER_LIFESTYLE_IMG =
    '/assets/img/design/product-rice-keeper-lifestyle.png'

export const PRODUCT_RICE_KEEPER_COLLAGE_IMG =
    '/assets/img/design/product-rice-keeper-detail-collage.png'

export const PRODUCT_DETAIL_SLUG_RICE_KEEPER = 'rice-keeper'

/** @param {string} slug */
export function productDesignCaseHref(slug) {
    return `${PRODUCT_DESIGN_PORTFOLIO_PATH}/${slug}`
}

export const PRODUCT_DETAIL_SLUG_MALRYEOSHU = 'malryeoshu-s'

/** @deprecated 이전 슬러그 — 상세 페이지에서 신규 경로로 리다이렉트 */
export const LEGACY_PRODUCT_DETAIL_SLUG_BREWCORE = 'brewcore'

export const VALID_PRODUCT_DETAIL_SLUGS = new Set([
    PRODUCT_DETAIL_SLUG_MALRYEOSHU,
    PRODUCT_DETAIL_SLUG_RICE_KEEPER,
    DUCATI_LASER_SLUG,
    MODU_INHALER_SLUG,
    ARROW_DRONE_SLUG,
    GREEN_VIEW_SLUG,
    INFANT_NASAL_ASPIRATOR_SLUG,
    PET_FRIENDS_SLUG,
])

/**
 * @type {Array<{
 *   slug?: string,
 *   title: string,
 *   excerpt: string,
 *   image?: string,
 *   imageAlt?: string,
 *   year?: string,
 *   tags?: string[],
 *   comingSoon?: boolean,
 * }>}
 */
const productPortfolioItemsSource = [
    {
        slug: PRODUCT_DETAIL_SLUG_MALRYEOSHU,
        title: '말려슈S · 말려줘 건조기',
        excerpt:
            '신발건조기·펫 드라이어로 확장한 원뿔형 스마트 건조 디바이스 제품 디자인 시리즈입니다.',
        image: PRODUCT_MALRYEOSHU_DETAIL_IMG,
        imageAlt: '말려슈S 신발건조기 — 상세 3D 렌더 콜라주',
        year: '2022',
        tags: ['신발건조기', '펫 드라이어', 'CMF'],
    },
    {
        slug: PRODUCT_DETAIL_SLUG_RICE_KEEPER,
        title: 'RiceKeeper 스마트 쌀통',
        excerpt:
            '100g 단위 정밀 토출·상단 다이얼 UI를 갖춘 타원형 스마트 쌀 보관·디스펜서 가전입니다.',
        image: PRODUCT_RICE_KEEPER_LIFESTYLE_IMG,
        imageAlt: 'RiceKeeper 스마트 쌀통 — 주방 인테리어 라이프스타일 컷',
        year: '2023',
        tags: ['스마트 쌀통', '주방가전', 'CMF'],
    },
    ducatiLaserPortfolioCard,
    moduInhalerPortfolioCard,
    arrowDronePortfolioCard,
    greenViewPortfolioCard,
    infantNasalAspiratorPortfolioCard,
    petFriendsPortfolioCard,
]

/** 연도순(최신 우선) · Coming soon 후순 */
export const productPortfolioItems = sortPortfolioByYear(productPortfolioItemsSource)

/** 제품 갤러리 1번 카드(연도순 최신) — 코담 디자인 메인 zigzag 섹션 */
export const productDesignFeaturedPortfolioItem = productPortfolioItems.find(
    (item) => item.slug,
)

const malryeoshuProcessPhases = [
    {
        id: 'concept',
        title: '콘셉트 & 형태',
        lede: '원뿔(절단 원뿔) 실루엣으로 바닥 면적을 줄이고, 좁은 공간·현관·드레스룸에 두기 쉬운 비율을 잡았습니다.',
        body: '상단 송풍구가 벌어지며 신발을 건조한다는 아이덴티티를 외형에 녹였습니다. 본체·디스플레이 밴드·송풍 상단을 수평 밴드로 나누어 기능 구역을 한눈에 읽히게 했습니다.',
    },
    {
        id: 'ux',
        title: '조작 & 피드백',
        lede: '전면 원형 버튼과 디지털 디스플레이로 온도·시간·풍량 상태를 직관적으로 확인합니다.',
        body: '디스플레이에는 온도(42°C), 타이머(11:20), 풍량·연결 신호 아이콘을 배치해 신발·펫 드라이어 모두에서 동일한 조작 피드백을 제공합니다. 하단 링 LED는 대기·가동 상태를 보조합니다.',
    },
    {
        id: 'cmf',
        title: 'CMF & 컬러',
        lede: '플라스틱 소재 기반의 매트 블랙·글로시 화이트 두 가지 컬러웨이를 제시했습니다.',
        body: '블랙은 프리미엄·차분한 주방/현관 톤, 화이트는 밝은 인테리어와의 조화를 목표로 마감 질감을 분리했습니다. 로고·버튼·디스플레이 영역은 동일한 컴포넌트 규격으로 맞춰 양산 시 부품 공용을 고려했습니다.',
    },
    {
        id: 'spec',
        title: '스펙 & 제작',
        lede: 'Rhino·KeyShot·Photoshop 파이프라인으로 CAD·렌더·시트를 정리했습니다.',
        body: '제품 크기 20×20×35(cm), 재질 PLASTIC 기준으로 내부 팬·공기 순환 구조를 전제한 볼륨을 설계했습니다. 마케팅용 제품 시트와 스펙 표는 동일 레이아웃으로 확장할 수 있게 구성했습니다.',
    },
]

const malryeoshuDeliverables = [
    '제품 콘셉트·원뿔 실루엣·송풍구 아이덴티티 정리',
    'Rhino 3D 모델 및 KeyShot 고해상도 렌더(컬러웨이별)',
    'CMF·디스플레이·조작부 UI 시안',
    '제품 스펙 시트(사이즈·재질·연도)',
    'Photoshop 기반 프레젠테이션·마케팅 컷',
]

const productShowcases = [
    {
        id: 'malryeoshu-s',
        kicker: 'Shoe dryer',
        title: '말려슈S',
        tagline: '다시 보송보송하게',
        image: PRODUCT_MALRYEOSHU_DETAIL_IMG,
        imageAlt:
            '말려슈S 신발건조기 — 전체 형태, 상단 송풍구·힌지, 하단 LED·환기 슬릿 클로즈업',
        description: [
            '원뿔형 3단 실루엣으로 현관·드레스룸 바닥 면적을 줄이면서도 안정감 있는 비율을 유지했습니다. 라이트 그레이 본체에 블랙 디스플레이 링, 다크 베이스 플레이트로 주방·현관 인테리어와 자연스럽게 어울리게 했습니다.',
            '상단은 힌지로 양쪽이 벌어지는 V형 송풍 구조로, 신발을 고정한 채 위쪽으로 따뜻한 공기를 보내는 사용 시나리오를 전제했습니다. 매트 블랙 상단 파트는 가열·송풍 영역임을 시각적으로 구분합니다.',
        ],
        features: [
            {
                title: '스마트 건조 42°C',
                text: '디스플레이 링에 표시되는 42°C 기준으로 소재 손상을 줄이면서 습기를 제거하는 온도 피드백을 전제했습니다.',
            },
            {
                title: '360° 디지털 링 UI',
                text: '온도·타이머(11:20)·풍량 아이콘을 한 눈에 읽는 랩어라운드 디스플레이로 조작 상태를 전달합니다.',
            },
            {
                title: '상단 개폐 송풍구',
                text: '리벳 힌지로 열리는 상단 날개가 제품 아이덴티티이며, 운동화부터 부츠까지 폭넓은 신발 형태를 수용합니다.',
            },
            {
                title: '하단 앰비언트 & 환기',
                text: '베이스 링 LED와 세로 슬릿 환기구로 프리미엄 감성과 공기 순환 구조를 동시에 표현했습니다.',
            },
        ],
    },
    {
        id: 'mallyeojwo',
        kicker: 'Smart pet dryer',
        title: '말려줘',
        tagline: '스마트 펫 드라이어',
        image: PRODUCT_MALLYEOJWO_PET_IMG,
        imageAlt:
            '말려줘 스마트 펫 드라이어 — 매트 블랙·글로시 화이트 컬러웨이 3D 렌더',
        description: [
            '말려슈S와 동일한 원뿔·디스플레이 링·베이스 조작 언어를 유지하면서, 반려동물 건조에 맞게 브랜딩과 슬로건을 재구성한 라인 확장입니다. 매트 메탈 블랙과 글로시 화이트 두 가지 프리미엄 마감을 병렬 제시했습니다.',
            '상단 캡의 메탈 포인트, 중간 디스플레이 밴드, 하단 플ared 베이스의 3티어 구성은 시리즈 공통 규격입니다. 반사되는 받침대 연출로 고급 가전 이미지를 강조했습니다.',
        ],
        features: [
            {
                title: '반려동물 안전 온도',
                text: '42°C 표시와 알람·팬 아이콘으로 피부에 무리 없는 건조 온도·시간·풍량 조절을 직관적으로 안내합니다.',
            },
            {
                title: '스마트 연결',
                text: '신호 강도 아이콘으로 앱·원격 모니터링 연동을 암시하는 스마트 가전 포지셔닝을 반영했습니다.',
            },
            {
                title: '듀얼 CMF',
                text: '매트 블랙은 차분한 프리미엄 톤, 글로시 화이트는 밝은 거실·욕실 공간에 맞춘 대비 컬러웨이입니다.',
            },
            {
                title: '시리즈 공용 플랫폼',
                text: '전면 원형 버튼·로고 영역·하단 LED 링·슬릿 베이스를 공통 모듈로 설계해 라인업 확장 비용을 줄였습니다.',
            },
        ],
    },
]

const riceKeeperProcessPhases = [
    {
        id: 'form',
        title: '형태 & 브랜딩',
        lede: '타원 단면·수직 실루엣과 전면 U자 라인으로 RiceKeeper 아이덴티티를 정리했습니다.',
        body: '라이트 그레이 본체·블랙 포인트·상단 메탈 다이얼의 3톤 구성으로 주방 가전 톤에 맞췄습니다. 하단 토출 서랍은 조리 동선 끝에 자연스럽게 닿도록 높이를 맞췄습니다.',
    },
    {
        id: 'dispense',
        title: '정밀 토출 UX',
        lede: '그립감 있는 녹슬 방지 다이얼과 디지털 링 UI로 1인분·중량 단위 토출을 표현했습니다.',
        body: '디스플레이에는 밥그릇 아이콘, 100g, 「1인분 토출중…」 상태 문구를 배치해 진행 중인 동작을 명확히 전달합니다. 조리대 위에서 한 손 조작이 가능한 상단 집중 레이아웃입니다.',
    },
    {
        id: 'fresh',
        title: '보관 & 환기',
        lede: '신선도 유지를 전제한 밀폐 볼륨과 하단 환기 슬릿 구조를 외형에 반영했습니다.',
        body: '본체 하단 둘레의 세로 환기구는 내부 습기·열 배출을 암시하고, 전원 포트·블랙 베이스 플레이트로 안정감 있는 설치 형태를 완성했습니다.',
    },
    {
        id: 'spec',
        title: '스펙 & 제작',
        lede: 'Rhino·KeyShot·Photoshop으로 라이프스타일·디테일 콜라주 렌더를 제작했습니다.',
        body: '제품 크기 235×415×470(mm), 재질 PLASTIC, 2023 스펙 기준입니다. 인테리어 연출 컷과 기능 클로즈업 콜라주를 분리해 마케팅·상세 페이지에 활용할 수 있게 구성했습니다.',
    },
]

const riceKeeperShowcases = [
    {
        id: 'rice-keeper-lifestyle',
        kicker: 'Lifestyle',
        title: 'RiceKeeper',
        tagline: '주방 인테리어 연출',
        image: PRODUCT_RICE_KEEPER_LIFESTYLE_IMG,
        imageAlt:
            'RiceKeeper 스마트 쌀통 — 밝은 주방·우드 패널 앞 라이프스타일 제품 컷',
        description: [
            '타원형 수직 실루엣과 라이트 그레이·블랙 2톤 마감으로 모던 주방에 자연스럽게 놓이도록 연출했습니다. 전면 U자 홈과 상단 메탈 다이얼이 시선을 모으고, 하단 토출 서랍은 조리대 높이에 맞춰 배치했습니다.',
            '좌측 여백을 살린 구도는 상세 페이지·배너에서 카피와 나란히 쓰기 좋습니다. 부드러운 자연광·은은한 그림자로 프리미엄 가전 감성을 강조했습니다.',
        ],
        features: [
            {
                title: '미니멀 실루엣',
                text: '군더더기 없는 원통·타원 형태로 조리대 위 공간을 차지하지 않습니다.',
            },
            {
                title: '2톤 CMF',
                text: '화이트/라이트 그레이 본체와 블랙 라인·베이스로 대비를 분명히 했습니다.',
            },
            {
                title: '브랜드 로고',
                text: '전면 상단 RiceKeeper 워드마크로 제품군 인지를 고정했습니다.',
            },
            {
                title: '공간 스토리',
                text: '우드·그레이 월 톤과 맞춘 라이프스타일 컷으로 사용 맥락을 제시합니다.',
            },
        ],
    },
    {
        id: 'rice-keeper-detail',
        kicker: 'Detail',
        title: '스마트 토출 & 구조',
        tagline: '100g · 1인분 정밀 디스펜스',
        image: PRODUCT_RICE_KEEPER_COLLAGE_IMG,
        imageAlt:
            'RiceKeeper — 정면 전체·상단 다이얼 UI(100g, 1인분 토출중)·하단 환기·전원 디테일 콜라주',
        description: [
            '좌측 전면 뷰에서 전체 비율과 토출 서랍, 상단 개폐 캡을 한눈에 확인할 수 있습니다. 우측 상단은 녹슬 처리 다이얼과 디지털 링 UI 클로즈업, 하단은 환기 슬릿·전원·베이스를 담았습니다.',
            '스마트 쌀통의 핵심인 신선도 유지·스마트 관리·자동 공급을 조작 피드백과 물리 구조로 풀어 낸 상세 콜라주입니다.',
        ],
        features: [
            {
                title: '정밀 분량 토출',
                text: '디스플레이에 100g·「1인분 토출중…」을 표시해 무게·인분 단위 배출을 직관적으로 안내합니다.',
            },
            {
                title: '다이얼 조작',
                text: '메탈 너링 다이얼로 분량·모드를 조절하는 프리미엄 터치포인트를 상단에 배치했습니다.',
            },
            {
                title: '토출 서랍',
                text: '하단 인출형 서랍에서 쌀을 받는 동선을 분리해 위생·편의를 높였습니다.',
            },
            {
                title: '하단 환기·전원',
                text: '둘레 환기 슬릿과 전원 포트·블랙 베이스로 설치·열 관리 구조를 표현했습니다.',
            },
        ],
    },
]

export const productCasesBySlug = {
    [PRODUCT_DETAIL_SLUG_MALRYEOSHU]: {
        pageTitle: '말려슈S · 말려줘 제품 디자인',
        masthead: '스마트 건조기 시리즈',
        mastheadSub: '말려슈S · 말려줘',
        metaDescription:
            '말려슈S 신발건조기와 말려줘 스마트 펫 드라이어 — 원뿔형 실루엣, 디스플레이 링 UI, CMF·3D 렌더 제품 디자인 사례입니다.',
        meta: {
            client: '말려슈S / 말려줘',
            year: '2022',
            scope: '제품 디자인 · Rhino · KeyShot · Photoshop',
            size: '20 × 20 × 35 (cm)',
            material: 'PLASTIC',
        },
        intro: {
            lead: '같은 원뿔형 플랫폼 위에 신발건조기·펫 드라이어 두 가지 사용 맥락을 올린 스마트 건조 디바이스 시리즈입니다.',
            left: '말려슈S는 「다시 보송보송하게」라는 메시지와 상단 개폐 송풍구로 신발 건조 경험을, 말려줘는 스마트 펫 드라이어로 반려동물 케어 톤을 담았습니다.',
            right: '디스플레이 링·전면 버튼·하단 LED·환기 슬릿은 공통 UX 언어입니다. Rhino·KeyShot·Photoshop으로 시트·콜라주·듀얼 컬러 렌더를 제작했습니다.',
        },
        hero: {
            src: PRODUCT_MALRYEOSHU_IMG,
            alt: '말려슈S 신발건조기 제품 시트 — 스펙·콘셉트·3D 렌더 개요',
        },
        productShowcases,
        processPhases: malryeoshuProcessPhases,
        deliverables: [
            ...malryeoshuDeliverables,
            '말려줘 펫 드라이어 라인 확장 CMF·브랜딩 시안',
            '시리즈 공통 모듈(디스플레이·베이스·상단 캡) 규격 정리',
        ],
        outro: [
            '하나의 형태 언어로 카테고리를 넓히면 브랜드 인지와 개발 효율을 동시에 얻을 수 있습니다.',
            '말려슈S·말려줘는 같은 플랫폼에서 타깃만 바꾼 대표 사례입니다.',
            '코담디자인은 생활·펫 가전의 형태·CMF·렌더까지 한 흐름으로 지원합니다.',
        ],
    },
    [PRODUCT_DETAIL_SLUG_RICE_KEEPER]: {
        pageTitle: 'RiceKeeper 스마트 쌀통',
        masthead: 'RiceKeeper',
        mastheadSub: 'Smart rice container',
        showcaseSectionTitle: '제품 특징 · 상세',
        metaDescription:
            'RiceKeeper 스마트 쌀통 — 100g 정밀 토출, 상단 다이얼 UI, 토출 서랍·환기 구조, 주방 라이프스타일 제품 디자인 사례입니다.',
        meta: {
            client: 'RiceKeeper',
            year: '2023',
            scope: '제품 디자인 · Rhino · KeyShot · Photoshop',
            size: '235 × 415 × 470 (mm)',
            material: 'PLASTIC',
        },
        intro: {
            lead: '스마트한 기능과 혁신적인 디자인으로 쌀을 보관·관리·토출하는 스마트 쌀통입니다.',
            left: '신선도 유지, 스마트 관리, 자동 쌀 공급을 핵심으로 하며, 상단 다이얼에서 100g·1인분 단위 토출 상태를 디스플레이로 확인합니다.',
            right: '라이프스타일 컷으로 주방 배치를, 디테일 콜라주로 다이얼 UI·토출 서랍·환기·전원 구조를 각각 전달합니다.',
        },
        hero: {
            src: PRODUCT_RICE_KEEPER_LIFESTYLE_IMG,
            alt: 'RiceKeeper 스마트 쌀통 — 주방 인테리어 라이프스타일 히어로 이미지',
        },
        productShowcases: riceKeeperShowcases,
        processPhases: riceKeeperProcessPhases,
        deliverables: [
            '제품 콘셉트·타원형 실루엣·기능 구역(상단·전면·측면·하단) 정리',
            'Rhino 3D 모델 및 KeyShot 고해상도 렌더',
            'CMF·디스플레이·디스펜서 UI 시안',
            '제품 스펙 시트(235×415×470 mm · PLASTIC · 2023)',
            'Photoshop 프레젠테이션·마케팅 컷',
        ],
        outro: [
            '히어로 라이프스타일 컷으로 공간 맥락을, 디테일 콜라주로 토출·조작·환기 스토리를 나누어 전달했습니다.',
            'RiceKeeper는 보관·정밀 토출·관리를 한 볼륨과 UI에서 읽히게 정리한 사례입니다.',
            '코담디자인은 주방·생활 가전의 제품 디자인·렌더 시각화를 지원합니다.',
        ],
    },
    [DUCATI_LASER_SLUG]: ducatiLaserDesignCase,
    [MODU_INHALER_SLUG]: moduInhalerDesignCase,
    [ARROW_DRONE_SLUG]: arrowDroneDesignCase,
    [GREEN_VIEW_SLUG]: greenViewDesignCase,
    [INFANT_NASAL_ASPIRATOR_SLUG]: infantNasalAspiratorDesignCase,
    [PET_FRIENDS_SLUG]: petFriendsDesignCase,
}

/** @param {string} slug */
export function getProductCaseBySlug(slug) {
    if (slug === LEGACY_PRODUCT_DETAIL_SLUG_BREWCORE) {
        return productCasesBySlug[PRODUCT_DETAIL_SLUG_MALRYEOSHU]
    }
    return productCasesBySlug[slug] ?? null
}

/** @param {string} slug */
export function resolveProductDetailSlug(slug) {
    if (slug === LEGACY_PRODUCT_DETAIL_SLUG_BREWCORE) {
        return PRODUCT_DETAIL_SLUG_MALRYEOSHU
    }
    return slug
}
